import { useQuery } from "@tanstack/react-query";
import { getFreeMarginOptions } from "@/api/cashier/@tanstack/react-query.gen";

export const useAccountFreeMargin = (tradingAccountID: string) => {
  const { data, isError, error, isLoading, refetch } = useQuery({
    ...getFreeMarginOptions({
      path: {
        tradingAccountID,
      },
    }),
    enabled: !!tradingAccountID,
  });

  return {
    freeMargin: data?.free_margin,
    isError,
    error,
    isLoading,
    refetch,
  };
};
